import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['type', 'index']);
  const createLocation = `createLocation(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createLocation} {
      id
    }
  }
`;
};
